import { Box } from "@mui/material";
import Fade from "@mui/material/Fade";
import { ProblemPopupButton } from "src/components/pages/main/problem_popup_button";
export const MainPage = () => {
  return (
    <Fade in={true} style={{ width: "100%", height: "100%" }} timeout={1000}>
      <Box
        width={"100%"}
        height={"100%"}
        p={"5vw"}
        display={"flex"}
        alignItems={"center"}
        flexDirection={"column"}
        className="space-5"
      >
        <p>
          この度は居酒屋桐蔵の持ち帰り謎をお買い上げいただき誠にありがとうございます！
        </p>
        <p>時間を気にせず、のんびりと当店の料理・お酒をお楽しみください。</p>
        <p>以下は問題の凡例となります。</p>
        <Box className="space-5">
          <Box>
            <ProblemPopupButton
              problemID={0}
              canPopup={false}
              status="unsolved"
            />
            - 未回答の問題
          </Box>
          <Box>
            <ProblemPopupButton
              problemID={0}
              canPopup={false}
              status="solved"
            />
            - 回答済みの問題
          </Box>
          <Box>
            <ProblemPopupButton
              problemID={0}
              canPopup={false}
              problemMetaCategory="onlyPerformance"
            />
            - 公演中のみ解答可能な問題
          </Box>
        </Box>
      </Box>
    </Fade>
  );
};
